import React from 'react';
import { motion } from 'framer-motion';
import { AssessmentQuiz } from '../components/AssessmentQuiz';
import { Testimonials } from '../components/Testimonials';
import { NewsletterSignup } from '../components/newsletter/NewsletterSignup';

export const Home = () => {
  return (
    <div className="min-h-screen bg-black text-white pt-16">
      {/* Hero Section */}
      <motion.section 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="relative h-screen flex items-center justify-center overflow-hidden"
      >
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-r from-purple-900/50 to-indigo-900/50" />
          <div className="absolute inset-0 bg-[url('/images/universe-bg.jpg')] bg-cover bg-center" />
        </div>
        
        <div className="relative z-10 text-center max-w-4xl mx-auto px-4">
          <motion.h1 
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-6xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-600"
          >
            Secrets of The Conquered
          </motion.h1>
          <motion.p 
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="text-xl mb-8 text-gray-300"
          >
            Ancient wisdom meets modern mastery. Transform your life with exclusive knowledge that's been hidden for centuries.
          </motion.p>
          <motion.button
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.6 }}
            className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:from-purple-700 hover:to-pink-700 transition-all"
          >
            Begin Your Journey
          </motion.button>
        </div>
      </motion.section>

      {/* Assessment Quiz Section */}
      <section className="py-24 bg-black">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-16">Discover Your Path</h2>
          <AssessmentQuiz />
        </div>
      </section>

      {/* Testimonials Section */}
      <Testimonials />

      {/* Newsletter Section */}
      <NewsletterSignup />

      {/* Pricing Section */}
      <section className="py-24 bg-black">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-8">Unlock Timeless Knowledge</h2>
          <div className="bg-gradient-to-r from-purple-900 to-indigo-900 rounded-2xl p-8">
            <h3 className="text-3xl font-bold mb-4">One-Time Access</h3>
            <p className="text-6xl font-bold mb-6">$10,000</p>
            <p className="text-xl mb-8 text-gray-300">
              Gain lifetime access to ancient wisdom and modern strategies that will transform every aspect of your life.
            </p>
            <button className="bg-white text-purple-900 px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all">
              Begin Your Transformation
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;